import axios from "axios";
import { AuthBody, AuthResponse } from "./models";

const postAuth = async (body: AuthBody): Promise<AuthResponse> => {
    try {
        const response = await axios.post(`/authBotUser`, body, {});
        return response as any; 
    } catch (error) {
        return error as AuthResponse;
    }
};

export { postAuth }